export const MenuClassName = 'p-0';
export const MenuDividerClassName = 'm-0 bg-bw03';
export const MenuItemClassName = 'flex flex-row gap-[8px] h-[36px] min-w-[205px] text-[14px] text-metricR text-bw08 hover:bg-bw02 hover:rounded-[4px] m-[4px]';
export const MenuItemIconClassName = 'w-[20px] h-[20px]';
